<ol class="steps">
  @for (step of steps(); track step; let i = $index) {
    <li class="step" [class.active]="i === activeIndex()" [attr.aria-current]="i === activeIndex() ? 'step' : null">
      <span class="number">{{ i + 1 }}</span>
      <span class="label">{{ step }}</span>
    </li>
  }
</ol>
<div class="track">
  <div class="fill" [style.width]="progress()"></div>
</div>
